import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "title": "审核通知公告",
      "size": "small",
      "bodyStyle": {
        padding: '1px'
      }
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('a-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _c('a-row', [_c('a-col', {
    staticClass: "card-left disabled-cursor",
    attrs: {
      "span": 18
    }
  }, [_c('a-card', {
    staticClass: "disabled-events",
    attrs: {
      "title": "通知公告内容",
      "bordered": false,
      "size": "small"
    }
  }, [_c('a-form-model', {
    attrs: {
      "model": _vm.formObject,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告分类",
      "prop": "cateName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    model: {
      value: _vm.formObject.cateName,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "cateName", $$v);
      },
      expression: "formObject.cateName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告标题",
      "prop": "title"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    model: {
      value: _vm.formObject.title,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "title", $$v);
      },
      expression: "formObject.title"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "紧急状态",
      "prop": "emergency"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.emergency,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "emergency", $$v);
      },
      expression: "formObject.emergency"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("常规")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("紧急")]), _c('a-radio', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("重要")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否置顶显示",
      "prop": "isTop"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.isTop,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isTop", $$v);
      },
      expression: "formObject.isTop"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "公告摘要",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "digest"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    style: {
      width: '97.5%'
    },
    attrs: {
      "placeholder": "请输入公告摘要",
      "max-length": 101,
      "rows": 2
    },
    model: {
      value: _vm.formObject.digest,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "digest", $$v);
      },
      expression: "formObject.digest"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告排序",
      "prop": "sort"
    }
  }, [_c('a-input-number', {
    style: {
      width: '100%'
    },
    attrs: {
      "min": 1,
      "max": 9999,
      "placeholder": "请输入公告排序"
    },
    model: {
      value: _vm.formObject.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "sort", $$v);
      },
      expression: "formObject.sort"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    model: {
      value: _vm.formObject.organPostName,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "organPostName", $$v);
      },
      expression: "formObject.organPostName"
    }
  })], 1)], 1)], 1), _vm.isDirector ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "25px"
    },
    style: {
      width: '100%'
    },
    attrs: {
      "label": "是否需财务总监审核",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-radio-group', {
    staticStyle: {
      "padding-left": "15px"
    },
    attrs: {
      "disabled": _vm.$route.query.type == 2
    },
    model: {
      value: _vm.formObject.isAppend,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isAppend", $$v);
      },
      expression: "formObject.isAppend"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.isDirectorJWB ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "25px"
    },
    style: {
      width: '100%'
    },
    attrs: {
      "label": "是否需要加签",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-radio-group', {
    staticStyle: {
      "padding-left": "15px"
    },
    attrs: {
      "disabled": _vm.$route.query.type == 2
    },
    model: {
      value: _vm.formObject.isAppend,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isAppend", $$v);
      },
      expression: "formObject.isAppend"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1) : _vm._e(), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "发布范围",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "range"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.range,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "range", $$v);
      },
      expression: "formObject.range"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("全校教职工")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("当前组织层级")]), _c('a-radio', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("当前组织层级指定人员")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("自定义")]), _vm.formObject.range === 1 || _vm.formObject.range === 3 ? _c('div', {
    staticStyle: {
      "height": "15px"
    }
  }) : _vm._e(), _vm.formObject.range === 1 ? _c('select-person', {
    ref: "selectPerson",
    attrs: {
      "businessId": _vm.businessId,
      "width": "97.5%",
      "height": "150px"
    },
    model: {
      value: _vm.formObject.customize,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "customize", $$v);
      },
      expression: "formObject.customize"
    }
  }) : _vm._e(), _vm.formObject.range === 3 ? _c('a-select', {
    style: {
      width: '100%'
    },
    attrs: {
      "allowClear": "",
      "show-search": "",
      "mode": "multiple",
      "placeholder": "请选择指定人员",
      "option-filter-prop": "children"
    },
    model: {
      value: _vm.optionVal,
      callback: function callback($$v) {
        _vm.optionVal = $$v;
      },
      expression: "optionVal"
    }
  }, _vm._l(_vm.formObject.scope, function (item) {
    return _c('a-select-option', {
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.userName) + " ")]);
  }), 1) : _vm._e()], 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticClass: "form-wangedit",
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "公告内容",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "content"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "margin-top": "10px",
      "width": "97.5%"
    }
  }, [_c('Toolbar', {
    staticStyle: {
      "border-bottom": "1px solid #ccc"
    },
    attrs: {
      "editor": _vm.editor,
      "defaultConfig": _vm.toolbarConfig,
      "mode": _vm.mode
    }
  }), _c('Editor', {
    staticStyle: {
      "height": "400px",
      "overflow-y": "hidden"
    },
    attrs: {
      "defaultConfig": _vm.editorConfig,
      "mode": _vm.mode
    },
    on: {
      "onCreated": _vm.onCreated
    },
    model: {
      value: _vm.formObject.content,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "content", $$v);
      },
      expression: "formObject.content"
    }
  })], 1)])], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "26px",
      "pointer-events": "auto"
    },
    attrs: {
      "label": "文件",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-list', {
    style: {
      width: '97.5%'
    },
    attrs: {
      "data-source": _vm.formObject.attach,
      "bordered": true
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-list-item-meta', [_c('a', {
          staticStyle: {
            "color": "#c7a368"
          },
          attrs: {
            "slot": "title",
            "target": "blank",
            "href": "".concat(_vm.config.baseUrl, "noticePath").concat(item.filePath),
            "download": item.fileName
          },
          slot: "title"
        }, [_vm._v(" " + _vm._s(item.fileName) + " ")])]), _c('div', [_vm._v(_vm._s(item.createTime))])], 1);
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a-card', {
    staticClass: "card-rigth",
    attrs: {
      "title": "流转记录",
      "bordered": false,
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.$route.query.type == 2 ? 'steps-content' : 'steps-content steps-content-view'
  }, [_c('a-timeline', _vm._l(_vm.flowList, function (item, index) {
    return _c('a-timeline-item', {
      key: index,
      attrs: {
        "color": _vm.colorItem[item.auditStatus]
      }
    }, [_c('div', {
      staticClass: "timeline-title",
      attrs: {
        "title": item.appendName
      }
    }, [_vm._v(" " + _vm._s(item.appendName || '') + " ")]), _c('a-card', {
      attrs: {
        "body-style": {
          padding: '10px'
        }
      }
    }, [_c('div', [_vm._v(" " + _vm._s(index === 0 ? '创建人' : '审核人') + "：" + _vm._s(item.userName) + " "), item.organName ? _c('a-tag', {
      attrs: {
        "color": "#bfbfbf"
      }
    }, [_vm._v(" " + _vm._s(item.organName) + "/" + _vm._s(item.postName) + " ")]) : _vm._e()], 1), _c('div', [_vm._v(" " + _vm._s(index === 0 ? '创建时间' : '审核时间') + "：" + _vm._s(item.auditDate) + " ")]), item.auditStatus === 0 && index != 0 ? _c('div', [_vm._v(" 审核结果： "), _c('a-tag', {
      staticClass: "tag-border-green"
    }, [_vm._v("通　过")])], 1) : _vm._e(), item.auditStatus === 1 && index != 0 ? _c('div', [_vm._v(" 审核结果： "), _c('a-tag', {
      staticClass: "tag-border-red"
    }, [_vm._v("不通过")])], 1) : _vm._e(), item.auditStatus === 2 && index != 0 ? _c('div', [_vm._v(" 审核结果： "), _c('a-tag', {
      staticClass: "tag-border-blue"
    }, [_vm._v("待审核")])], 1) : _vm._e(), (item.auditStatus === 0 || item.auditStatus === 1) && index != 0 ? _c('div', {
      staticClass: "timeline-opinion",
      attrs: {
        "title": item.auditOpinion
      }
    }, [_vm._v(" 审核意见：" + _vm._s(item.auditOpinion || '') + " ")]) : _vm._e()])], 1);
  }), 1)], 1), _vm.$route.query.type == 2 ? _c('div', {
    staticClass: "steps-form"
  }, [_c('a-divider'), _c('a-form-model', {
    ref: "auditForm",
    attrs: {
      "model": _vm.auditFormObj,
      "rules": _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "审核结果",
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    on: {
      "change": _vm.auditStatusChange
    },
    model: {
      value: _vm.auditFormObj.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.auditFormObj, "auditStatus", $$v);
      },
      expression: "auditFormObj.auditStatus"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("通过")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("不通过")])], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "审核意见",
      "prop": "auditOpinion"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入审核意见",
      "max-length": 201,
      "rows": 5
    },
    model: {
      value: _vm.auditFormObj.auditOpinion,
      callback: function callback($$v) {
        _vm.$set(_vm.auditFormObj, "auditOpinion", $$v);
      },
      expression: "auditFormObj.auditOpinion"
    }
  })], 1), _vm.isAuditAppend ? _c('a-form-model-item', {
    staticClass: "is-audit",
    attrs: {
      "label": "是否需财务总监审核",
      "prop": "isAppend"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.auditFormObj.isAppend,
      callback: function callback($$v) {
        _vm.$set(_vm.auditFormObj, "isAppend", $$v);
      },
      expression: "auditFormObj.isAppend"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1) : _vm._e(), _vm.isAuditPresAppend ? _c('a-form-model-item', {
    staticClass: "is-audit",
    attrs: {
      "label": "是否需要理事长、校长审核",
      "prop": "isAppend"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.auditFormObj.isAppend,
      callback: function callback($$v) {
        _vm.$set(_vm.auditFormObj, "isAppend", $$v);
      },
      expression: "auditFormObj.isAppend"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1) : _vm._e(), _c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "wrapper-col": {
        span: 18,
        offset: 6
      }
    }
  }, [_c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" 提交 ")]), _vm.isCountersign ? _c('span', [_c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.appendAudit(2);
      }
    }
  }, [_vm._v(" 加前签 ")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.appendAudit(3);
      }
    }
  }, [_vm._v(" 加后签 ")])], 1) : _vm._e()], 1)])], 1)], 1) : _vm._e()])], 1)], 1)], 2), _c('a-drawer', {
    attrs: {
      "title": _vm.appendTitle,
      "width": "50%",
      "visible": _vm.visibleMode,
      "body-style": {
        paddingBottom: '80px'
      },
      "zIndex": 999,
      "placement": "left"
    },
    on: {
      "close": _vm.onClose
    }
  }, [_vm.signRecord.length === 0 ? _c('div', [_c('a-empty')], 1) : _c('div', _vm._l(_vm.signRecord, function (sign, index) {
    return _c('div', {
      key: index
    }, [_c('a-row', {
      style: {
        marginBottom: '10px'
      },
      attrs: {
        "gutter": 12
      }
    }, [_c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_c('div', {
      staticClass: "text-ellipsis"
    }, [_vm._v("加签名称： "), _c('span', {
      style: {
        color: '#c2c2c2'
      },
      attrs: {
        "title": sign.appendName
      }
    }, [_vm._v(_vm._s(sign.appendName))])])]), _c('a-col', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "text-ellipsis"
    }, [_vm._v("排序： "), _c('span', {
      style: {
        color: '#c2c2c2'
      }
    }, [_vm._v(_vm._s(sign.sort))])])]), _c('a-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "text-ellipsis"
    }, [_vm._v("处理人或岗位： "), sign.postName && sign.userName && sign.organName ? _c('span', [_c('span', {
      style: {
        color: '#c2c2c2'
      },
      attrs: {
        "title": "".concat(sign.userName, "(").concat(sign.organName, "/").concat(sign.postName, ")")
      }
    }, [_vm._v(_vm._s(sign.userName) + " (" + _vm._s(sign.organName) + " / " + _vm._s(sign.postName) + ")")])]) : sign.postName && sign.organName ? _c('span', [_c('span', {
      style: {
        color: '#c2c2c2'
      },
      attrs: {
        "title": "".concat(sign.organName, "/").concat(sign.postName)
      }
    }, [_vm._v(_vm._s(sign.organName) + " / " + _vm._s(sign.postName))])]) : _c('span', [_c('span', {
      style: {
        color: '#c2c2c2'
      },
      attrs: {
        "title": sign.userName || sign.postName
      }
    }, [_vm._v(_vm._s(sign.userName) + " / " + _vm._s(sign.postName))])])])])], 1)], 1);
  }), 0), _c('a-divider'), _c('a-form-model', {
    ref: "addForm",
    attrs: {
      "model": _vm.appendFormObj,
      "label-col": {
        span: 0
      },
      "wrapper-col": {
        span: 24
      }
    }
  }, [_vm._l(_vm.appendFormObj.records, function (record, index) {
    return _c('div', {
      key: index
    }, [_c('a-row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('a-col', {
      attrs: {
        "span": 5
      }
    }, [_c('a-form-model-item', {
      attrs: {
        "prop": 'records.' + index + '.appendname',
        "rules": {
          required: true,
          message: '请输入加签名称',
          trigger: 'blur'
        }
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      attrs: {
        "placeholder": "请输入加签名称"
      },
      model: {
        value: record.appendname,
        callback: function callback($$v) {
          _vm.$set(record, "appendname", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "record.appendname"
      }
    })], 1)], 1), _c('a-col', {
      attrs: {
        "span": 2
      }
    }, [_c('a-form-model-item', {
      attrs: {
        "prop": 'records.' + index + '.sort',
        "rules": {
          required: true,
          message: '排序',
          trigger: 'blur'
        }
      }
    }, [_c('a-input-number', {
      style: {
        width: '100%',
        pointerEvents: 'none'
      },
      attrs: {
        "min": 1,
        "max": 9999,
        "precision": 0,
        "placeholder": "排序"
      },
      model: {
        value: record.sort,
        callback: function callback($$v) {
          _vm.$set(record, "sort", $$v);
        },
        expression: "record.sort"
      }
    })], 1)], 1), _c('a-col', {
      attrs: {
        "span": 16
      }
    }, [_c('a-form-model-item', {
      attrs: {
        "prop": 'records.' + index + '.customize',
        "rules": {
          type: 'object',
          required: true,
          fields: {
            postData: {
              type: 'array',
              required: record.customize.userData.length === 0 && record.customize.postData.length === 0,
              message: '请选择岗位或者成员',
              trigger: 'change'
            },
            userData: {
              type: 'array',
              required: record.customize.userData.length === 0 && record.customize.postData.length === 0,
              message: '请选择岗位或者成员',
              trigger: 'change'
            }
          }
        }
      }
    }, [_c('select-person-genera', {
      staticClass: "publish-person",
      attrs: {
        "tabList": _vm.userTabList,
        "isRadio": 1,
        "width": "100%",
        "height": "40px"
      },
      model: {
        value: record.customize,
        callback: function callback($$v) {
          _vm.$set(record, "customize", $$v);
        },
        expression: "record.customize"
      }
    })], 1)], 1), _c('a-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a-popconfirm', {
      attrs: {
        "title": "确认删除吗？数据将不会保存!",
        "ok-text": "确认",
        "cancel-text": "取消"
      },
      on: {
        "confirm": function confirm($event) {
          return _vm.removeDomain(record);
        }
      }
    }, [_c('a-icon', {
      style: {
        fontSize: '20px',
        margin: '5px'
      },
      attrs: {
        "type": "minus-circle-o",
        "title": "删除"
      }
    })], 1)], 1)], 1)], 1);
  }), _c('a-form-model-item', {
    attrs: {
      "wrapper-col": {
        span: 24
      }
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v(" 添加 ")], 1)], 1)], 2), _c('div', {
    staticClass: "footer"
  }, [_c('a-button', {
    style: {
      marginRight: '8px'
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.modalLoading
    },
    on: {
      "click": function click($event) {
        return _vm.handleOk();
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };